import { connect } from 'react-redux'
import AudioSelector from './AudioSelector'
import { State } from '../../dataStore/reducers/reducerType'
import get from 'lodash/get'
import { AudioSelectorProps } from './types'

const mapStateToProps = (state: State, props): AudioSelectorProps => ({
  isDialInAvailable: get(state.config.featureFlags, 'dialIn', false),
  isDialInConnected: props.isDialInConnected,
  selectedMicrophoneDeviceId: props.selectedMicrophoneDeviceId,
  onMicrophoneChange: props.onMicrophoneChange,
  onAudioSourceChange: props.onAudioSourceChange,
  selectedAudioSource: props.audioSource
})

export default connect(mapStateToProps)(AudioSelector)
